"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var RenderIf_1 = __importDefault(require("../../RenderIf"));
var VideoPlayerIds_1 = __importDefault(require("../../../VideoPlayerIds"));
var VideoButtonFullscreen_1 = __importDefault(require("../styles/VideoButtonFullscreen"));
var ButtonFullscreenActiveSvg_1 = __importDefault(require("../assets/ButtonFullscreenActiveSvg"));
var ButtonFullscreenDeactiveSvg_1 = __importDefault(require("../assets/ButtonFullscreenDeactiveSvg"));
var VideoButtonFullscreen = function (_a) {
    var controller = _a.controller, isInFullscreen = _a.isInFullscreen;
    return (jsx_runtime_1.jsxs(VideoButtonFullscreen_1.default, __assign({ id: VideoPlayerIds_1.default.ButtonFullscreen, onClick: controller === null || controller === void 0 ? void 0 : controller.handleFullscreenMode }, { children: [jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: isInFullscreen }, { children: jsx_runtime_1.jsx(ButtonFullscreenActiveSvg_1.default, {}, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !isInFullscreen }, { children: jsx_runtime_1.jsx(ButtonFullscreenDeactiveSvg_1.default, {}, void 0) }), void 0)] }), void 0));
};
exports.default = VideoButtonFullscreen;
